module.exports = __webpack_public_path__ + "static/img/product6.c380da1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/new/product6.png
// module id = AgRB
// module chunks = 0